module.exports = __webpack_public_path__ + "img/radius-upleft.009c9342.svg";